module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA4CAQAAAARWLNhAAABcElEQVR4Ae2YK5CCMQyEf4lXyF8id4aISCQSiUTdVOIV8iQSiVcnkcjKk0gkshLHsxBXwk333hvd/fpuk+YqDRIl9Q/+kCRRQ+MRulgXzQqBNboPAQV7F6IpS4PLqBAPJkpintOVts0T0lZWeQyxDMhL67c3RAakpqTbQBu/3G35gH8AEnmRMb8A5gxAlp5UYR7LogO01RkCDTDuYHtZibdxhwHIF4YhCFOEWEDUAGhXNgWEAUgIA5AQBiAhDEBCGICEMAAD4QZANTwOeTnFVHZ3RDwhDMD42mBjANLXzAeYfdRekncNAhaekFP0380eveoPDqZ3+5229bfpxHqvvfoHbSQ2OVr/qhjIPtvvdVD9LoJKyvYHjKrfpoAlYJjUf3Baux50yngytzcXzLiP/pz7bVlS/kXoSP540b6OaPGK8FM/vxhiSARgKQc5YMEDXO4e7P+zzG8OoBdD6OUcekGKXlKjFwWtrNlPT5k7y5pH58uBu3xiw+oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_logout.png
// module id = W4Nc
// module chunks = 8